import { createFeatureSelector, createSelector } from '@ngrx/store'
import { MENU_ITEMS_FEATURE_KEY, MenuItemsState, menuItemsAdapter } from './menu-items.reducer'

export const selectMenuItemsState = createFeatureSelector<MenuItemsState>(MENU_ITEMS_FEATURE_KEY)

const { selectAll, selectEntities } = menuItemsAdapter.getSelectors()

export const selectMenuItemsLoaded = createSelector(selectMenuItemsState, (state: MenuItemsState) => state.loaded)
export const selectEditCreateLoaded = createSelector(
  selectMenuItemsState,
  (state: MenuItemsState) => state.editCreateLoaded,
)

export const selectAllMenuItems = createSelector(selectMenuItemsState, (state: MenuItemsState) => selectAll(state))

export const selectMenuItemsEntities = createSelector(selectMenuItemsState, (state: MenuItemsState) =>
  selectEntities(state),
)

export const selectSelectedId = createSelector(selectMenuItemsState, (state: MenuItemsState) => state.selectedId)

export const selectEntity = createSelector(selectMenuItemsEntities, selectSelectedId, (entities, selectedId) =>
  selectedId ? entities[selectedId] : undefined,
)

export const selectResourcesLoaded = createSelector(
  selectMenuItemsState,
  (state: MenuItemsState) => state.resourcesLoaded,
)
